/***
 * @file:å¤´é¨ç»ä»¶
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Component, ComponentFactoryResolver, Inject, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { SettingsService } from '@ithinkdt/shared/browser';
import { ThemeConfig, ThemeUserConfig } from '@ithinkdt/theme/models';
import { COLLAPSED_KEY } from '@ithinkdt/theme/setting-drawer';

@Component({
  selector: 'dt-layout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  searchToggleStatus: boolean;
  themeConfig: ThemeConfig;
  headerSettingInstance: any;
  @ViewChild('headerContainer', { read: ViewContainerRef, static: false })
  container: ViewContainerRef;
  @Input() topMenu = false;
  @Input() fixWidth = false;
  @Input() collapsed = false;
  @Input() fixHeader = false;
  @Input() shouldHide: boolean;

  constructor(public settings: SettingsService, private resolver: ComponentFactoryResolver) {
    this.themeConfig = this.settings.userConfig['theme'] || {};
  }

  ngOnInit() {
    if (this.themeConfig && this.themeConfig.headerComp) {
      // console.log('this.themeConfig.userSettingComp', this.userConfig.userSettingComp);
      this.headerSettingInstance = this.themeConfig.headerComp;
      // this.createComponent();
    }
    // if (this.themeConfig['headerComp']) {
    //   this.createComponent();
    // }
  }

  // createComponent() {
  //   this.container.clear();
  //   const factory: ComponentFactory<any> = this.resolver.resolveComponentFactory(this.themeConfig['headerComp']);
  //   this.container.createComponent(factory);
  // }

  toggleCollapsedSidebar() {
    this.settings.setLayout(COLLAPSED_KEY, !this.settings.layout.collapsed);
  }

  searchToggleChange() {
    this.searchToggleStatus = !this.searchToggleStatus;
  }
}
